import { Suspense, useEffect } from 'react';
import { BrowserRouter } from 'react-router';
import { useApplyAppearance } from '../hooks/useApplyAppearance';
import { removeSplash } from '../lib/splash';
import { SplashScreen } from './components/SplashScreen';
import { AppRouter } from './router';

function ThemedApp() {
  useApplyAppearance();

  // Remove the HTML splash only after the theme is applied — prevents a dark-flash
  // when the user's system preference is dark mode.
  useEffect(() => {
    removeSplash();
  }, []);

  return (
    <Suspense fallback={<SplashScreen />}>
      <AppRouter />
    </Suspense>
  );
}

export function App() {
  return (
    <BrowserRouter>
      <ThemedApp />
    </BrowserRouter>
  );
}

export default App;
